// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// import required modules
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Keyboard, Mousewheel, Navigation, Pagination } from 'swiper';

const Portfoliio = () => {
    return (

        <section className="portfolio section" id="portfolio">
            <h2 className="section__title">Portfolio</h2>
            <span className="section__subtitle">Most recent work</span>

            <div className="portfolio__container container swp1 swiper">

                <>
                    <Swiper
                        spaceBetween={30}
                        slidesPerView={1}
                        slidesPerGroup={1}
                        loop={true}
                        grid={{ fill: 'column', rows: 2 }}
                        navigation={
                            {
                                nextEl: '.swiper-button-swiper-next',
                                prevEl: '.swiper-button-swiper-prev',
                            }
                        }
                        scrollbar={{ draggable: true }}
                        modules={[Navigation, Pagination, Mousewheel, Keyboard]}

                    >
                        <SwiperSlide>
                            {/* <!-- ================PORTFOLIO 1 --> */}
                            <div className="portfolio__content container grid">
                                <img src="assets/img/portfolio1.png" alt="porfolio__img1" className="portfolio__img" />
                                <div className="portfolio__data">
                                    <h3 className="portfolio__title">FKT </h3>
                                    <p className="portfolio__description">Front-end application for FKT Ambanilanana . / wcc 2023
                                    </p>
                                    <a href="https://front-s1-ekipa.netlify.app/" target='_blank' className="button button--flex button--small portfolio__button">
                                        Demo
                                        <i className="uil uil-arrow-right button__icon"></i>
                                    </a>
                                </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            {/* <!-- ================PORTFOLIO 2 --> */}
                            <div className="portfolio__content container grid">
                                <img src="assets/img/portfolio2.png" alt="porfolio__img2" className="portfolio__img" />
                                <div className="portfolio__data">
                                    <h3 className="portfolio__title">Simple Portfolio</h3>
                                    <p className="portfolio__description">A simple web application made with CSS HTML. / wcc 2023
                                    </p>
                                    <a href="https://front-s3-ekipa.netlify.app/" target='_blank' className="button button--flex button--small portfolio__button">
                                        Demo
                                        <i className="uil uil-arrow-right button__icon"></i>
                                    </a>
                                </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            {/* <!-- ================PORTFOLIO 3 --> */}
                            <div className="portfolio__content container grid">
                                <img src="assets/img/portfolio3.png" alt="porfolio__img1" className="portfolio__img" />
                                <div className="portfolio__data">
                                    <h3 className="portfolio__title">Zazakely</h3>
                                    <p className="portfolio__description">
                                        An Landing Page made with HTML/CSS , to present games for kids. / wcc 2023
                                    </p>
                                    <a href="https://front-s2-ekipa.netlify.app/" target='_blank' className="button button--flex button--small portfolio__button">
                                        Demo
                                        <i className="uil uil-arrow-right button__icon"></i>
                                    </a>
                                </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            {/* <!-- ================PORTFOLIO 3 --> */}
                            <div className="portfolio__content container grid">
                                <img src="assets/img/portfolio4.png" alt="porfolio__img1" className="portfolio__img" />
                                <div className="portfolio__data">
                                    <h3 className="portfolio__title">Evenementia</h3>
                                    <p className="portfolio__description">
                                        A web application made with React JS , to publish the events of a company.
                                    </p>
                                    <a href="https://evenementia.vercel.app/" target='_blank' className="button button--flex button--small portfolio__button">
                                        Demo
                                        <i className="uil uil-arrow-right button__icon"></i>
                                    </a>
                                </div>
                            </div>
                        </SwiperSlide>

                    </Swiper>

                </>

                {/* <!-- Add arows pagination --> */}
                <div className="swiper-button-swiper-next">
                    <i className="uil uil-angle-right-b swiper-portfolio-icon"></i>
                </div>
                <div className="swiper-button-swiper-prev">
                    <i className="uil uil-angle-left-b swiper-portfolio-icon"></i>
                </div>


            </div>
        </section>
    )
}

export default Portfoliio